module.exports = __webpack_public_path__ + "static/img/draw-second-title.ba53b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw-second-title.png
// module id = pzIv
// module chunks = 0